/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import Select from 'react-select';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of products
 */
class SelectorSex extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            options: [
                {value: 'F', label: <Translate id="profile-register.female" options={{renderInnerHtml: false}}/>},
                {value: 'M', label: <Translate id="profile-register.male" options={{renderInnerHtml: false}}/>},
                {value: 'O', label: <Translate id="profile-register.other" options={{renderInnerHtml: false}}/>},
                {value: 'U', label: <Translate id="profile-register.unknown" options={{renderInnerHtml: false}}/>}
                ], // The options to fill the selection
            value: this.props.data.sex
        };
    }

    componentWillReceiveProps(props){
        this.setState({ value: props.value});
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (object) => {
        this.setState({value: object.value}, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <div>

                {
                    this.state.options.length > 0 ?
                        <Select
                            value={this.state.options.find(option => option.value === this.state.value)}
                            isDisabled={this.state.disabled} options={this.state.options} name="countries"
                            onChange={this.handleChange} placeholder=
                                {
                                    <Translate id="profile-register.select-sex" options={{renderInnerHtml: false}}/>
                                }
                        /> : null}
            </div>
        )
    }
}

export default SelectorSex;